export default // eslint-disable-next-line max-len
'<svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19"><path d="M680 386v9a4 4 0 0 0 8 0v-9h2v9a6 6 0 0 1-12 0v-9h2Zm-4 17h16v2h-16v-2Z" transform="translate(-676 -386)" style="fill-rule:evenodd"/></svg>';
